import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import configurationStore from './store/configureStore';
import AppConfig from './appConfig';
import { Auth0Provider } from '@auth0/auth0-react';

const store = configurationStore();

// Auth0: always use app root as callback - avoids path-specific URLs (e.g. /Home/) not in Auth0's allowed list
const redirectUri = typeof window !== 'undefined' ? window.location.origin + '/' : '/';

const app = (
    <Provider store={store}>
        <App />
    </Provider>
);

const rootApp = AppConfig.auth0.useAuth0 ? (
    <Auth0Provider
        domain={AppConfig.auth0.domain}
        clientId={AppConfig.auth0.clientId}
        authorizationParams={{
            redirect_uri: redirectUri,
            audience: AppConfig.auth0.audience || undefined,
        }}
    >
        {app}
    </Auth0Provider>
) : app;

ReactDOM.render(rootApp, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
